import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=1f168414"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionHeader: require('/opt/build/repo/components/section/Header.vue').default,RegisterForm: require('/opt/build/repo/components/register/Form.vue').default})
